import { useEffect, useState } from "react";
import { ConsentPopUp } from "./ConsentPopUp.jsx";
import { ConsentSettings } from "./ConsentSettings.jsx";
import { installCookies } from "./hooks/installCookies";
import { updateGoogleConsent } from "./hooks/consentMode.js";

export const setCookie = (name, value, days) => {
  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
};

export const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop()?.split(";").shift();
  return null;
};

export function ConsentBanner() {
  const [showCookieBanner, setShowCookieBanner] = useState(true);
  const [currentPage, setCurrentPage] = useState("cookie");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const cookieConsent = getCookie("userConsent");
    if (cookieConsent) {
      const parsed = JSON.parse(cookieConsent);
      updateGoogleConsent(parsed); // restore consent
      installCookies(parsed); // install extra vendors
      setShowCookieBanner(false);
    }
    setLoading(false);
  }, []);

  const saveCookies = (trackingConsent) => {
    updateGoogleConsent(trackingConsent);
    installCookies(trackingConsent);
    setCookie("userConsent", JSON.stringify(trackingConsent), 365);
    setShowCookieBanner(false);
  };

  const saveAllCookies = () => {
    const trackingConsent = {
      marketing: true,
      analytics: true,
      preferences: true,
      sale_of_data: true,
    };
    saveCookies(trackingConsent);
  };

  const saveOnlyNecessary = () => {
    const trackingConsent = {
      marketing: false,
      analytics: false,
      preferences: false,
      sale_of_data: false,
    };
    saveCookies(trackingConsent);
  };

  if (!showCookieBanner || loading) return null;

  return (
    <>
      {currentPage === "settings" ? (
        <ConsentSettings
          saveAllCookies={saveAllCookies}
          saveCookies={saveCookies}
          goBack={() => setCurrentPage("cookie")}
        />
      ) : (
        <ConsentPopUp
          openSettings={() => setCurrentPage("settings")}
          openDatasecruity={() => (window.location.href = "/datenschutz")}
          saveAllCookies={saveAllCookies}
          saveOnlyNecessary={saveOnlyNecessary}
        />
      )}
    </>
  );
}
